<template>
  <div class="management-container">
    <!-- 轮播图 -->
    <van-swipe
      class="my-swipe"
      :loop="true"
      indicator-color="white"
      @change="onChange"
    >
      <van-swipe-item
        v-for="(item, index) in managementList"
        :key="index"
      >
        <goods-item
          :videoIsPlay="videoIsPlay"
          :goodsType="item.type"
          :goodsSrc="item.img"
          :goodsPoster="item.coverImg"
          :goodsSource="item.detailImg"
        ></goods-item>
      </van-swipe-item>
    </van-swipe>
    <!-- 馆藏简介 -->
    <div class="management-info">
      <p class="management-info-title">{{ managementInfo.title }}</p>
      <p class="management-info-content">
        {{ managementInfoContent }}
        <a
          @click="showMore"
          v-if="managementInfo.content && managementInfo.content.length > 80 && managementInfoContent && managementInfoContent.length <= 83"
        >
          展开
          <img />
          <i
            style="font-weight: bold;"
            class="el-icon-arrow-down"
          ></i>
        </a>
        <a
          @click="hideMore"
          v-if="managementInfoContent && managementInfoContent.length > 83"
        >
          收起
          <img />
          <i
            style="font-weight: bold;"
            class="el-icon-arrow-up"
          ></i>
        </a>
      </p>
    </div>
    <!-- 馆藏商品 -->
    <div class="order-menu">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo row-start"
        mode="horizontal"
        @select="handleSelect"
      >
        <el-menu-item
          index="1"
          class="el-menu-item1"
        >
          全部
          <img
            v-if="activeIndex == 1"
            src="../assets/icon/list-select.png"
          />
        </el-menu-item>
        <el-menu-item
          index="2"
          class="el-menu-item1"
        >
          即将开售
          <img
            v-if="activeIndex == 2"
            src="../assets/icon/list-select.png"
          />
        </el-menu-item>
        <el-menu-item index="3">
          已售罄
          <img
            v-if="activeIndex == 3"
            src="../assets/icon/list-select.png"
          />
        </el-menu-item>
      </el-menu>
    </div>
    <van-list
      v-if="!noList"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="load"
    >
      <div class="collection-list">
        <collection-item
          v-for="item in collectionList"
          :key="item.id"
          :collectionInfo="item"
        >
        </collection-item>
      </div>

    </van-list>
    <div
      v-if="noList"
      class="col-center"
      style="width:100%;margin-top:10vh;"
    >
      <img
        style="width:6.5rem;height:auto;margin-bottom:1.375rem;"
        src="../assets/icon/no-list.png"
      />
      <p style="font-size: 16px;font-family: lantingheiweight;font-weight: 500;color: #666666;line-height: 22px;margin-bottom: 5vh;">暂无数据</p>
    </div>
  </div>
</template>
<script>
import api from '../api/index-client'
import Vue from 'vue'
import GoodsItem from '../components/GoodsItem.vue'
import CollectionItem from '../components/CollectionItem.vue'

import { Swipe,SwipeItem,List,Popup } from 'vant';
import { Menu,MenuItem } from 'element-ui';
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(List);
Vue.use(Popup);

export default {
  components: {
    GoodsItem,CollectionItem
  },
  data () {
    return {
      videoIsPlay: true,
      loading: false,
      finished: false,
      noList: false,
      goodsParam: {
        page: 0,
        limit: 12,
      },
      managementList: [
      ],
      collectionList: [
      ],
      allProductList: [],
      openSoonProductList: [],
      soldProductList: [],
      managementInfo: {
        title: '',
        content: ''
      },
      managementInfoContent: '',
      activeIndex: '1',
    }
  },
  mounted () {
    this.$store.commit('SHOW_APPLOADING')
  },
  methods: {
    // 图片类型
    imageType (type) {
      return type == 'bmp' ||
        type == 'jpg' ||
        type == 'jpeg' ||
        type == 'png' ||
        type == 'gif'
    },
    // 视频类型
    videoType (type) {
      return type == 'avi' ||
        type == 'wmv' ||
        type == 'mpeg' ||
        type == 'mp4' ||
        type == 'm4v' ||
        type == 'mov' ||
        type == 'flv' ||
        type == 'f4v' ||
        type == 'rmvb' ||
        type == '3gp'
    },
    // 下拉加载
    load () {
      this.loading = true
      this.goodsParam.page += 1
      if (this.allProductList.length == 0) {
        this.getManagementInfo()
      } else {
        this.selectManagementInfo()
      }
    },
    // 根据tab切换改变内容
    selectManagementInfo () {
      var productList = this.activeIndex == '1' ? this.allProductList : this.activeIndex == '2' ? this.openSoonProductList : this.soldProductList
      this.noList = productList.length == 0 ? true : false
      productList.map((i,j) => {
        this.collectionList.push({
          id: i.id,
          image: i.image,
          name: i.storeName,
          exclusiveBuyType: i.exclusiveBuyType,
          limitInfo: i.limitInfo,
          price: i.price,
          cateId: i.cateId,
          isOpen: i.isOpen,
          stock: i.stock,
          sellStatus: i.sellStatus,
          startTime: i.startTime,
          endTime: i.endTime
        })
      })
      this.finished = true
      this.loading = false
      this.$store.commit('HIDE_APPLOADING')
    },
    // 获取管藏详情
    getManagementInfo () {

      api
        .get('collect/library/detail/' + this.$route.query.id)
        .then(result => {
          if (result.data.success) {
            this.managementInfo.title = result.data.data.name
            this.managementInfo.content = result.data.data.brief
            this.managementInfoContent = this.managementInfo.content && this.managementInfo.content.length > 80 ? this.managementInfo.content.substring(0,80) + '...' : this.managementInfo.content

            result.data.data.materials.map(i => {
              if (this.imageType(i.name.split('.')[i.name.split('.').length - 1])) {
                this.managementList.push({
                  type: 'img',
                  img: i.url
                })
              } else if (this.videoType(i.name.split('.')[i.name.split('.').length - 1])) {
                this.managementList.push({
                  type: 'video',
                  detailImg: i.url
                })
              }
            })
            // 全部商品
            this.allProductList = result.data.data.productVoList
            // 即将开售商品
            this.soldProductList = this.allProductList.filter(i => (i.endTime && (((new Date()).getTime()) > (new Date(i.endTime.replace(/-/g,'/'))).getTime())) || i.stock == 0 || i.sellStatus == '已售罄' || i.sellStatus == '售完')
            // 已售罄商品
            this.openSoonProductList = this.allProductList.filter(i => i.sellStatus == '即将开放' || i.endTime && (new Date(i.endTime.replace(/-/g,"/"))).getTime() > (new Date()).getTime() && i.startTime && (new Date(i.startTime.replace(/-/g,"/"))).getTime() > (new Date()).getTime() && i.isOpen == 1)

            this.selectManagementInfo()

          } else {
            this.finished = true
            this.$toast({
              message: result.data.msg,
              icon: require('../assets/icon/toast-error.png'),
            });
          }
        })
      this.$store.commit('HIDE_APPLOADING')
    },
    showMore () {
      this.managementInfoContent = this.managementInfo.content
    },
    hideMore () {
      this.managementInfoContent = this.managementInfo.content && this.managementInfo.content.substring(0,80) + '...'
    },
    onChange () {
      this.videoIsPlay = this.videoIsPlay ? false : true
    },
    // tab切换
    handleSelect (key) {
      this.activeIndex = key
      this.goodsParam.page = 0
      this.collectionList = []
      this.load()
    },
  },
}
</script>
<style lang="less" scoped>
.management-container {
  width: 100vw;
  height: auto;
  background: #1c1c1c;
  /deep/.video-player {
    z-index: 100;
  }
  /deep/.player {
    z-index: 101;
  }
  /deep/.van-swipe__indicators {
    bottom: 10px;
    left: auto;
    right: -1%;
  }
  /deep/.van-swipe__indicator {
    width: 5px;
    height: 5px;
    background-color: transparent;
    border: 1px solid #ffffff;
    border-radius: 100%;
    opacity: 1;
    -webkit-transition: opacity 1s, background-color 0.2s;
    transition: opacity 1s, background-color 0.2s;
  }
  .management-info {
    width: 94vw;
    min-height: 36px;
    padding: 17px 0;
    height: auto;
    background: rgba(42, 42, 42, 0.89);
    backdrop-filter: blur(8px);
    margin-left: 3%;
    margin-top: 0px;
    .management-info-title {
      width: 90%;
      margin-left: 5%;
      text-align: left;
      font-size: 22px;
      font-family: lantingheiweight;
      font-weight: bold;
      color: #ffffff;
      line-height: 31px;
      letter-spacing: 1px;
    }
    .management-info-content {
      width: 90%;
      margin-left: 5%;
      font-size: 14px;
      font-family: lantingheiweight;
      font-weight: 700;
      color: #ffffff;
      line-height: 24px;
      margin-top: 10px;
      letter-spacing: 1px;
    }
  }
  .order-menu {
    width: 94vw;
    margin-left: 3vw;
    position: inherit;
    background: transparent !important;
    .el-menu {
      background: transparent !important;
      background-color: transparent !important;
    }
    .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
    .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
    .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
      background: transparent !important;
      background-color: transparent !important;
    }
    .el-menu-item {
      font-size: 14px;
    }
    .el-menu-item1 {
      margin-right: 20px;
    }
  }
  .collection-list {
    width: 94vw;
    margin-left: 3vw;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 10px;
  }
}
</style>